import { MsalAuthProvider, LoginType } from 'react-aad-msal';

console.log(process.env);

const config = {
  auth: {
    authority: process.env.REACT_APP_AD_AUTHORITY,
    clientId: process.env.REACT_APP_AD_CLIENT_ID,
    redirectUri: process.env.REACT_APP_AD_REDIRECT_URI,
    postLogoutRedirectUri: 'https://login.microsoftonline.com/common/oauth2/logout',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
const authenticationParameters = {
  scopes: [process.env.REACT_APP_AD_SCOPE_API],
};
export const authProvider = new MsalAuthProvider(
  config,
  authenticationParameters,
  { loginType: LoginType.Redirect }
);
export { authProvider as default };
